class DisclosureOpener {
    button = null;
    Disclosure = null;
    DisclosureDetails = null;
    storeHeader = null;

    constructor(button, disclosureSelector) {
        this.button = button;
        this.Disclosure = document.querySelector(disclosureSelector);
        this.DisclosureDetails = this.Disclosure.querySelector('details');
        this.storeHeader = document.querySelector('store-header');
        this.button.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick() {
        if (this.Disclosure && this.DisclosureDetails) {
            this.scrollToDisclosure();
            this.openDisclosure();
        }
    }

    scrollToDisclosure() {
        window.scrollTo({
            top: this.getDiscloseWindowPosition() - this.getStoreHeaderHeight(),
            left: 0,
            behavior: 'smooth',
        });
    }

    openDisclosure() {
        if (!this.DisclosureDetails.open) {
            this.Disclosure.open();
        }
    }

    getStoreHeaderHeight() {
        return this.storeHeader.offsetHeight;
    }

    getDiscloseWindowPosition() {
        return this.DisclosureDetails.getBoundingClientRect().top + window.scrollY;
    }
}
